<template>
  <div>
    <slot v-if="$slots.benefitGiftsOptional" name="benefitGiftsOptional" />
    <div class="optional-module" v-if="giftList && giftList.length">
      <div class="title" aria-label="已购权益赠品">已购权益赠品</div>
      <div v-for="(item, index) in giftList" :key="index" >
        <giveaway-pop-item
          :giftItem="item"
          :positionKey="index"
        ></giveaway-pop-item>
      </div>
    </div>
  </div>

</template>

<script>
import GiveawayPopItem from '../giveaway-pop-item'

export default {
  name: 'BenefitGifts',
  components: {
    GiveawayPopItem
  },
  props: {
    giftList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
}
</script>

<style scoped lang="scss" src="./index.scss" />
